const REGEXP_OS_ANDROID = /android/i;
const REGEXP_OS_IOS = /iphone|ipad|ipod/i;

const REGEXP_WECHAT = /micromessenger|wechatdevtools/i;
const REGEXP_APP_WECHAT = /miniprogram/i;
const REGEXP_APP_ZHUZHER = /zhuzher/i;
const REGEXP_APP_LEBANG = /vkstaffassistant/i;
const REGEXP_APP_ONEWO = /onewospace/i;
const REGEXP_APP_YZS = /yzs_platform/i; //明源云-云助手


export const platformUtils = () => {
  const { screen, navigator } = window;
  const userAgent = navigator.userAgent;
  let ua = userAgent || navigator.userAgent;
  // 全部转小写
  if(ua){
    ua = ua.toLowerCase();
  }

  const isAndroid = REGEXP_OS_ANDROID.test(ua);

  const isiOS = REGEXP_OS_IOS.test(ua);

  const isInZhuzher = REGEXP_APP_ZHUZHER.test(ua);

  const isInZhuYingTai = REGEXP_APP_LEBANG.test(ua) || REGEXP_APP_ONEWO.test(ua);
  // 是否在微信环境
  const isInWechat = REGEXP_WECHAT.test(ua);
  // 是否在小程序环境
  const isInWechatApp = REGEXP_APP_WECHAT.test(ua);

  const isIPhoneX = isiOS && screen.height === 812 && screen.width === 375;
  
  const isOneWO = REGEXP_APP_ONEWO.test(ua);

  const isYzs=REGEXP_APP_YZS.test(ua);

  
  return {
    isAndroid,
    isiOS,
    isIPhoneX,
    isInZhuzher,
    isInZhuYingTai,
    isInWechat,
    isInWechatApp,
    isOneWO,
    isYzs
  };
};

const platform = platformUtils();
export default platform;
